/* eslint-disable arrow-parens */
import { useState, useCallback, useEffect, useContext, useRef, Suspense } from "react";
import { useNavigate } from "react-router-dom";
import { useDebouncedCallback } from "use-debounce";
import { Paper, Select, MenuItem, Grid, Button, TextField, InputAdornment, Tooltip } from "@material-ui/core";
import { withStyles, Theme } from "@material-ui/core/styles";
import { ADMIN_DASHBOARD_HEADER } from "../../../../../../../constants/caption/dashboardHeader";
import { AuthContext, UIContext } from "../../../../../../../contexts";
import GENDERS from "../../../../../../../constants/genders";
import { MARITAL_STATUSES } from "../../../../../../../constants/maritalStatus";
import initCapitalize from "../../../../../../../utils/commonFunctions/initCapitalize";
import DateFnsUtils from "@date-io/date-fns";
import { MuiPickersUtilsProvider, KeyboardDatePicker } from "@material-ui/pickers";
import "date-fns";
import { DynamicForm } from "../../../../../../../@types/dynamicForm.types";
import { MaterialUiPickersDate } from "@material-ui/pickers/typings/date";
import { MemberTypes } from "../../../../../../../@types/components/member.types";
import useRouteParam from "../../../../../../../hooks/useRouteParam";
import { trackPromise } from "react-promise-tracker";
import { api } from "../../../../../../../utils/api";
import ROLES from "../../../../../../../constants/roles";

import SendIcon from "@material-ui/icons/Send";
import ReplyIcon from "@material-ui/icons/Reply";
import EventIcon from "@material-ui/icons/Event";
import InfoIcon from "@material-ui/icons/Info";
import { infoTitleMessage } from "../../../../../../../constants/infoTitleMessage";
import { ConditionPosition } from "ag-grid-community/dist/lib/filter/provided/simpleFilter";
import { Validation } from "../../../../../../../@types/validation.types";
import { LazySnackbarAPI } from "../../../../../../shared";
import ExtractRouteParams from "../../../../../../../utils/commonFunctions/extractRouteParams";
import SnackbarAPICall from "../../../../../../shared/snackbar/SnackbarAPICall";
import { SnackbarProps } from "../../../../../../../@types/snackbarAPI.types";

import "../../../../../../../globalStyles/paperFormStyles.css";
import {
	dateTimeZoneConverter,
	dateTimeZoneDOBConverter,
	dateTimeZoneMaterialUIConverter
} from "../../../../../../../utils/commonFunctions/date";
import { handleSSNFormat } from "../../../../../../../utils/commonFunctions/SSN";

const LightTooltip = withStyles((theme: Theme) => ({
	tooltip: {
		backgroundColor: "#f5f5f9",
		color: "rgba(0, 0, 0, 0.87)",
		boxShadow: theme.shadows[1],
		maxWidth: 130,
		fontSize: 11
	}
}))(Tooltip);

const EditProfileInformation = (): JSX.Element => {
	const querySSN = useRouteParam("qs");
	const queryGroupNumber = useRouteParam("gn");
	const [editProfileForm, setEditProfileForm] = useState<DynamicForm>();
	const [employee, setEmployee] = useState<any>({
		member_id: "",
		employee_number: null,
		first_name: "",
		middle_name: "",
		last_name: "",
		email: "",
		SSN: "",
		date_of_birth: "",
		hire_date: "",
		gender: "",
		is_tobacco: "",
		marital_status: "",
		upload_type: ""
	});
	const { setDashboardHeader } = useContext(UIContext);
	const [exisitingMemberId, setExistingMemberId] = useState<string>("");
	const [employeeMongoID, setEmployeeMongoID] = useState<string>("");
	const [memberIdExists, setMemberIdExists] = useState(false);
	const [hasEditProfileSubmitClick, setHasEditProfileSubmitClick] = useState(false);
	const navigate = useNavigate();
	const [validation, setValidation] = useState<Validation>({
		employee: {},
		status: "invalid"
	});
	const _validation = useRef<Validation>();
	const routeParam = ExtractRouteParams(); // This is to extract the route after ?(Question Mark)
	const [snackbarAPICallProps, setSnackbarAPICallProps] = useState<SnackbarProps>({
		open: false,
		severity: undefined,
		message: "",
		handleSnackbarClose: (event, reason) => {
			if (reason === "clickaway") return;
			setSnackbarAPICallProps(
				Object.assign({}, snackbarAPICallProps, {
					open: false
				})
			);
		}
	});
	const { user } = useContext(AuthContext);

	const handleValidation = useCallback(async () => {
		const { member_id, first_name, last_name, date_of_birth, gender, marital_status, is_tobacco } = employee;
		_validation.current = {
			...validation,
			employee: {},
			status: "invalid"
		};
		let flag = true;

		// employee validation checking
		if (member_id.length === 0) {
			_validation.current.employee["member_id"] = "Employee Id is required";
			_validation.current["status"] = "invalid";
			flag = false;
		}
		if (first_name.length === 0) {
			_validation.current.employee["first_name"] = "First Name is required";
			_validation.current["status"] = "invalid";
			flag = false;
		}
		if (is_tobacco.length === 0) {
			_validation.current.employee["is_tobacco"] = "Tobacco is required";
			_validation.current["status"] = "invalid";
			flag = false;
		}
		if (last_name.length === 0) {
			_validation.current.employee["last_name"] = "Last Name is required";
			_validation.current["status"] = "invalid";
			flag = false;
		}
		if (String(date_of_birth).length === 0) {
			_validation.current.employee["date_of_birth"] = "Date of birth is required";
			_validation.current["status"] = "invalid";
			flag = false;
		}
		if (gender.length === 0) {
			_validation.current.employee["gender"] = "Gender is required";
			_validation.current["status"] = "invalid";
			flag = false;
		}
		if (marital_status.length === 0) {
			_validation.current.employee["marital_status"] = "Marital Status is required";
			_validation.current["status"] = "invalid";
			flag = false;
		}

		if (flag === true) _validation.current["status"] = "valid";
		else {
			_validation.current["status"] = "invalid";
			alert("Please, fill all required fields!");
		}
		setValidation(Object.assign({}, _validation.current));
		return _validation.current["status"];
	}, [employee, validation]);

	const findMemberId = useDebouncedCallback(async (value: string) => {
		if (value !== "") {
			const email = await api.find.findMemberId(value);
			if (email === false) {
				setMemberIdExists(false);
			} else {
				setMemberIdExists(true);
			}
		} else {
			setMemberIdExists(false);
		}
	}, 500);

	// const handleEmployeeDateChange = useCallback(
	// 	(_date: MaterialUiPickersDate, name: string) => {
	// 		const date = new Date(_date as Date);
	// 		const parsedDate = date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate();
	// 		setEmployee(Object.assign({}, employee, { [name]: parsedDate }));
	// 	},
	// 	[employee]
	// );

	const handleEmployeeDateChange = useCallback(
		(_date: MaterialUiPickersDate, name: string) => {
			const parsedDate = _date as unknown as string;
			setEmployee(Object.assign({}, employee, { [name]: parsedDate }));
		},
		[employee]
	);

	const handleEmployeeInformationChange = useCallback(
		(event: React.ChangeEvent<HTMLInputElement>) => {
			const { name } = event.target;
			let { value } = event.target;

			if (name === "member_id") {
				if (value !== exisitingMemberId) findMemberId(value);
				setEmployee(Object.assign({}, employee, { [name]: value }));
			} else if (name === "first_name") {
				const regex = /^[a-zA-Z]+$/;
				if (value.match(regex) || value === "") {
					value = value.slice(0, 1).toUpperCase() + value.slice(1);
					setEmployee(Object.assign({}, employee, { [name]: value }));
				} else if (/\s/g.test(value)) {
					setEmployee(Object.assign({}, employee, { [name]: value }));
				}
			} else setEmployee(Object.assign({}, employee, { [name]: value }));
		},
		[employee, exisitingMemberId, findMemberId]
	);

	const getMembersByEmployeeSSN = useCallback(async (_employee_SSN: string, group_number: number) => {
		const findEmployeeQuery = {
			group_number,
			employee_SSN: _employee_SSN
		};

		const response = await trackPromise(api.member.getMembersByEmployeeSSN(findEmployeeQuery));
		// console.log("Members: ", response);
		if (response) {
			// console.log("Members: ", response);
			const { memberInstance } = response;
			memberInstance.forEach(async (member: MemberTypes) => {
				const { role } = member;
				if (role === ROLES.employee) {
					const {
						_id,
						member_id,
						first_name,
						middle_name,
						last_name,
						employee_number,
						email,
						SSN,
						date_of_birth,
						hire_date,
						gender,
						marital_status,
						upload_type,
						is_tobacco
					} = member;

					setEmployeeMongoID(_id as string);
					setExistingMemberId(member_id as string);

					const dateOfBirth = dateTimeZoneDOBConverter(date_of_birth as string);

					// Converting Hire Date
					const hireDate = dateTimeZoneDOBConverter(hire_date as string);

					const _member = {
						member_id,
						first_name,
						middle_name,
						last_name,
						employee_number,
						email,
						SSN,
						date_of_birth: dateOfBirth,
						hire_date: hireDate,
						gender,
						marital_status,
						upload_type,
						is_tobacco: is_tobacco == true ? "Yes" : "No"
					};
					setEmployee(Object.assign({}, _member));
				}
			});
		}
	}, []);

	const handleRedirectToMemberDetails = useCallback(() => {
		const pathname = `/employer/member?${routeParam}`;
		navigate(pathname);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const handleEditProfileSubmitClick = useCallback(
		async (event: React.MouseEvent<HTMLButtonElement>) => {
			try {
				event.preventDefault();
				const validation = await handleValidation();
				if (validation === "valid") {
					const { date_of_birth, hire_date } = employee;
					const DOB = new Date(date_of_birth);
					const hireDate = new Date(hire_date);

					const payload: MemberTypes = {
						...employee,
						is_tobacco: employee.is_tobacco == "Yes" || employee.is_tobacco == true ? true : false,
						date_of_birth: DOB.getFullYear() + "-" + (DOB.getMonth() + 1) + "-" + DOB.getDate(),
						hire_date: hireDate.getFullYear() + "-" + (hireDate.getMonth() + 1) + "-" + hireDate.getDate()
					};

					// console.log("Payload", payload);
					const response: MemberTypes = await trackPromise(
						api.member.editEmployeeInformationById(payload, employeeMongoID as string)
					);

					if (response) {
						setHasEditProfileSubmitClick(true);
						// console.log("Response", response);

						// alert("Edit Profile Submission Successfully!");
						setSnackbarAPICallProps(
							Object.assign({}, snackbarAPICallProps, {
								open: true,
								message: "Profile Edited Successfully!",
								severity: "success"
							})
						);

						setTimeout(() => {
							handleRedirectToMemberDetails();
						}, 2000);
					}
				} else {
					setHasEditProfileSubmitClick(false);
				}
			} catch (error) {
				setHasEditProfileSubmitClick(false);
				alert("Profile Edit unsuccessful!");
				throw error;
			}
		},
		// eslint-disable-next-line react-hooks/exhaustive-deps
		[employee, handleValidation]
	);

	useEffect(() => {
		setDashboardHeader(ADMIN_DASHBOARD_HEADER.edit_profile);
	}, [setDashboardHeader]);

	useEffect(() => {
		if (querySSN && queryGroupNumber) getMembersByEmployeeSSN(querySSN as string, queryGroupNumber as number);
	}, [getMembersByEmployeeSSN, queryGroupNumber, querySSN]);

	useEffect(() => {
		setEditProfileForm(
			Object.assign(
				{},
				{
					"Profile Information": [
						{
							label: "Employee Id",
							name: "member_id",
							onChange: (event: React.ChangeEvent<HTMLInputElement>) =>
								handleEmployeeInformationChange(event),
							value: employee.member_id,
							type: "textfield"
						},
						{
							label: "WLT Employee number",
							name: "employee_number",
							onChange: () => null,
							value: employee.employee_number,
							type: "textfield"
						},
						{
							label: "First Name",
							name: "first_name",
							value: employee.first_name,
							onChange: (event: React.ChangeEvent<HTMLInputElement>) =>
								handleEmployeeInformationChange(event),
							type: "textfield"
						},
						{
							label: "Middle Name",
							name: "middle_name",
							value: employee.middle_name,
							onChange: (event: React.ChangeEvent<HTMLInputElement>) =>
								handleEmployeeInformationChange(event),
							type: "textfield"
						},
						{
							label: "Last Name",
							name: "last_name",
							value: employee.last_name,
							onChange: (event: React.ChangeEvent<HTMLInputElement>) =>
								handleEmployeeInformationChange(event),
							type: "textfield"
						},
						{
							label: "Email",
							name: "email",
							onChange: () => null,
							value: employee.email,
							type: "textfield"
						},
						{
							label: "ALT-ID",
							name: "SSN",
							onChange: () => null,
							value: handleSSNFormat(user, employee.SSN),
							type: "textfield"
						},
						{
							label: "Date Of Birth",
							name: "date_of_birth",
							value: employee.date_of_birth,
							onChange: (date: MaterialUiPickersDate, name: string) =>
								handleEmployeeDateChange(date, name),
							type: "date"
						},
						{
							label: "Hire Date",
							name: "hire_date",
							onChange: () => null,
							value: employee.hire_date,
							type: "textfield"
						},
						{
							label: "Gender",
							name: "gender",
							value: employee.gender,
							onChange: (event: React.ChangeEvent<HTMLInputElement>) =>
								handleEmployeeInformationChange(event),
							type: "select",
							options: GENDERS
						},
						{
							label: "Marital Status",
							name: "marital_status",
							value: employee.marital_status,
							onChange: (event: React.ChangeEvent<HTMLInputElement>) =>
								handleEmployeeInformationChange(event),
							type: "select",
							options: MARITAL_STATUSES
						},
						{
							label: "Tobacco",
							name: "is_tobacco",
							value: employee.is_tobacco,
							onChange: (event: React.ChangeEvent<HTMLInputElement>) =>
								handleEmployeeInformationChange(event),
							type: "select",
							options: ["Yes", "No"]
						}
						// {
						// 	label: "Upload Type",
						// 	name: "upload_type",
						// 	onChange: () => null,
						// 	value: employee.upload_type,
						// 	type: "textfield"
						// }
					]
				}
			)
		);
	}, [employee, handleEmployeeInformationChange, handleEmployeeDateChange]);

	// console.log("Employee", employee);
	// console.log("ExisitingMemberId", exisitingMemberId);
	// console.log("EmployeeMongoID", employeeMongoID);

	return (
		<div className="edit-profile-information-container">
			<Suspense fallback={<div />}>
				<SnackbarAPICall snackbarProps={snackbarAPICallProps} />
			</Suspense>
			<div className="pf-action-button-container" id="pf-action-button-container">
				<Button
					className="button-green"
					onClick={handleEditProfileSubmitClick}
					variant="contained"
					disabled={hasEditProfileSubmitClick}
					style={{
						cursor: hasEditProfileSubmitClick ? "not-allowed" : "pointer",
						pointerEvents: "unset"
					}}
				>
					<span className="button-label-with-icon">Submit</span>
					<span>
						<SendIcon className="button-icon" />
					</span>
				</Button>
			</div>
			<Grid container spacing={1} className="pf-grid-container">
				{editProfileForm &&
					Object.entries(editProfileForm).map(([key, value], index) => {
						return (
							<div key={index}>
								<div className="pf-title">{key}</div>
								<Paper className="pf-paper-container" variant="outlined" elevation={3}>
									{value.map((field, index) => {
										const { name, label, value, type, onChange } = field;
										return (
											<Grid item key={index} xl={12} lg={12} md={12} sm={12} xs={12}>
												<Grid container spacing={1} className="pf-label">
													<Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
														<div className="pf-label-text" id="pf-label-text">
															{label}
														</div>
													</Grid>
													<Grid item xs={9} sm={9} md={9} lg={9} xl={9}>
														{type === "textfield" ? (
															<TextField
																className="input-text-field"
																id={
																	name === "email" ||
																	name === "hire_date" ||
																	name === "employee_number" ||
																	name === "SSN" ||
																	name === "upload_type"
																		? "disabled-input-text-field"
																		: "input-text-field"
																}
																value={
																	name === "upload_type"
																		? initCapitalize(value)
																		: value
																}
																name={name}
																onChange={onChange}
																variant="outlined"
																disabled={
																	name === "email" ||
																	name === "hire_date" ||
																	name === "employee_number" ||
																	name === "SSN" ||
																	name === "upload_type"
																		? true
																		: false
																}
																InputProps={{
																	endAdornment: (
																		<>
																			{name === "email" ||
																			name === "hire_date" ||
																			name === "employee_number" ||
																			name === "SSN" ||
																			name === "upload_type" ? (
																				<InputAdornment position="end">
																					<LightTooltip
																						title={
																							name === "employee_number"
																								? infoTitleMessage.employee_number
																								: name === "email"
																								? infoTitleMessage.email
																								: name === "SSN"
																								? infoTitleMessage.SSN
																								: name === "hire_date"
																								? infoTitleMessage.hire_date
																								: name === "upload_type"
																								? infoTitleMessage.upload_type
																								: ""
																						}
																						placement="right-start"
																						arrow
																					>
																						<InfoIcon
																							style={{
																								color: "#808080",
																								fontSize: "20px",
																								// cursor: !showSaveButton
																								// 	? "default"
																								// 	: "pointer",
																								pointerEvents: "unset"
																							}}
																						/>
																					</LightTooltip>
																				</InputAdornment>
																			) : null}
																		</>
																	),
																	readOnly:
																		name === "email" ||
																		name === "hire_date" ||
																		name === "employee_number" ||
																		name === "SSN" ||
																		name === "upload_type"
																			? true
																			: false
																}}
																helperText={
																	name === "member_id" && memberIdExists
																		? "Member Id already exists!"
																		: validation.employee[name]
																}
																style={{
																	pointerEvents: "unset",
																	width: "340px",
																	borderRadius: 50
																}}
															/>
														) : type === "select" ? (
															<>
																<Select
																	id="text-align-options"
																	name={name}
																	value={value}
																	onChange={onChange}
																	style={{
																		pointerEvents: "unset",
																		minWidth: 180,
																		textAlign: "left",
																		overflowY: "visible"
																	}}
																	MenuProps={{
																		style: { zIndex: 35960 }
																	}}
																	inputProps={{ "aria-label": "Without label" }}
																>
																	<MenuItem value="" disabled>
																		Select Value
																	</MenuItem>
																	{field?.options?.map((option) => {
																		return (
																			<MenuItem key={option} value={option}>
																				{name !== "state"
																					? initCapitalize(option as string)
																					: option}
																			</MenuItem>
																		);
																	})}
																</Select>
																{validation && validation.employee[name] ? (
																	<div className="details">
																		<span className="select-validation-text2">
																			{field.schema === "dependent"
																				? validation.employee[name]
																				: ""}
																		</span>
																	</div>
																) : null}
															</>
														) : type === "date" ? (
															<MuiPickersUtilsProvider utils={DateFnsUtils}>
																<KeyboardDatePicker
																	className="from-date-input"
																	id="from-date-input"
																	inputVariant="outlined"
																	label={label}
																	name={name}
																	format="MM/dd/yyyy"
																	error={false}
																	value={value}
																	onChange={(date: MaterialUiPickersDate) =>
																		onChange(date, name)
																	}
																	InputProps={{
																		readOnly: true
																	}}
																	InputLabelProps={{
																		shrink: true
																	}}
																	keyboardIcon={
																		<EventIcon
																			style={{
																				color: "#7cb342"
																			}}
																		/>
																	}
																	KeyboardButtonProps={{
																		"aria-label": "change date"
																	}}
																	style={{
																		pointerEvents: "unset",
																		width: "340px",
																		borderRadius: 50
																	}}
																	helperText={validation.employee[name]}
																/>
															</MuiPickersUtilsProvider>
														) : null}
													</Grid>
												</Grid>
											</Grid>
										);
									})}
								</Paper>
							</div>
						);
					})}
			</Grid>
			<div className="pf-action-button-container margin-top-action-button" id="pf-action-button-container">
				<Button
					className="button-green"
					onClick={handleEditProfileSubmitClick}
					variant="contained"
					disabled={hasEditProfileSubmitClick}
					style={{
						cursor: hasEditProfileSubmitClick ? "not-allowed" : "pointer",
						pointerEvents: "unset"
					}}
				>
					<span className="button-label-with-icon">Submit</span>
					<span>
						<SendIcon className="button-icon" />
					</span>
				</Button>
			</div>
		</div>
	);
};

export default EditProfileInformation;
